import { ApiMatchEventIdTimelineGet200ResponseDataMatchTimelineInner } from '@/api/livescore/generated';
import Goal from '@/components/icons/Goal';
import { useLivescoreMatch } from '@/context/LivescoreMatchContext';
import { cn } from '@/utils/cn';

const SUPPORTED_TYPES = ['score_change', 'yellow_card', 'red_card'];

type EventType = (typeof SUPPORTED_TYPES)[number];

const EventIcon = ({ type }: { type: EventType }) => {
  switch (type) {
    case 'score_change':
      return <Goal className="sm:w-3.5 w-2" />;
    case 'yellow_card':
      return <div className="bg-[#F2D30B] sm:w-[11px] w-2 sm:h-3.5 h-2.5 rounded-[2.66px]" aria-hidden />;
    case 'red_card':
      return <div className="bg-[#F20B0F] sm:w-[11px] w-2 sm:h-3.5 h-2.5 rounded-[2.66px]" aria-hidden />;
    default:
      return null;
  }
};

const LivescoreMatchReportItem = ({
  event,
}: {
  event: ApiMatchEventIdTimelineGet200ResponseDataMatchTimelineInner;
}) => {
  if (!SUPPORTED_TYPES.includes(event.type)) {
    return null;
  }

  const { match } = useLivescoreMatch();

  return (
    <li
      className={cn(
        'flex items-center sm:h-10 h-7 px-5 dark:even:bg-black-500 even:bg-white_theme-100 w-full first:rounded-t-lg last:rounded-b-lg',
        event.competitor === 'away' && 'flex-row-reverse',
      )}
    >
      <p className={cn('sm:w-10 w-6 font-bold sm:text-[12px] text-[9px]', event.competitor === 'away' && 'text-right')}>
        {event.match_time ? <>{event.match_time}&#8217;</> : ''}
      </p>
      <div className={cn('flex items-center gap-1.5', event.competitor === 'away' && 'flex-row-reverse')}>
        <EventIcon type={event.type} />
        <p className="sm:text-[12px] text-[9px] font-medium">
          {event.players?.[0]?.name ?? match.sport_event.competitors[event.competitor === 'home' ? 0 : 1].name}
        </p>
        {!event.players?.[0]?.name && (
          <p className="sm:text-[12px] text-[9px] font-medium text-gray-400">(Nieznany zawodnik)</p>
        )}
        {event.players?.[1] && (
          <p className="sm:text-[12px] text-[9px] font-medium text-gray-400">({event.players[1].name})</p>
        )}
      </div>
    </li>
  );
};

export default LivescoreMatchReportItem;
